import React, { useState } from 'react';
import { Group, SegmentedControl } from '@mantine/core';

import type { MasterEntityType } from '@api/entity-attributes';
import EntityMasterTab from './EntityMasterTab';

/**
 * The things a merchant HAS that are configuration rather than catalogue: where it ships
 * from, where it sells, and who it buys from. Products and materials are the Catalog
 * section in the sidebar; the relationships between any of these live in Vendor Mapping.
 */
const TABS: { value: MasterEntityType; label: string }[] = [
    { value: 'WAREHOUSE', label: 'Warehouses' },
    { value: 'CHANNEL', label: 'Channels' },
    { value: 'VENDOR', label: 'Vendors' },
];

const EntityMasterSection: React.FC = () => {
    const [active, setActive] = useState<MasterEntityType>('WAREHOUSE');

    return (
        <>
            <Group mb="md">
                <SegmentedControl
                    value={active}
                    onChange={(v) => setActive(v as MasterEntityType)}
                    data={TABS}
                    size="xs"
                />
            </Group>
            <EntityMasterTab key={active} entityType={active} />
        </>
    );
};

export default EntityMasterSection;
